import React from "react";
import PropTypes from "prop-types";
import {
  CustomCheckbox,
  DisplayFlex,
} from "../../../../../../CommonComponents/commonStyles";
import { TableLabel, CheckboxLabel, GrantSectionHeading , GrantSectionHeading2} from "../../style";
import FormBase from "../../../../../../CommonComponents/FormBase/FormBase";
import Contents, {
  AlertContent,
  Types,
} from "../../../../../../CommonComponents/ContentMessages";

class PermissionToPublishForm extends FormBase {
  constructor(props) {
    super(props);
    this.state = {
      publishName: {
        value: props.publishCheck || false,
        touched: false,
        valid: "",
      },
    };
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
  }

  formatData = () => ({
    data: {
      publishName: !this.state.publishName.value,
    },
    isFormValid: this.checkFormValid(this.state),
  });

  render() {
    const { page } = this.props;
    const { publishName } = this.state;
    return (
      <div>
        <GrantSectionHeading2>Permission to publish</GrantSectionHeading2>
        <TableLabel>
          {page && (
            <AlertContent
              page={page}
              type={[Types.PAGE_PERMISSION_TO_PUBLISH]}
              keyProperty={`${page} - Permission to Publish`}
              property={"field_permission_to_publish_cont"}
              html={true}
              defaultMessage={
                "The updated grant amount will be calculated based on allocation percentage decided in earlier stages"
              }
            />
          )}
        </TableLabel>
        <DisplayFlex>
          <CustomCheckbox
            id="chkpublishName"
            name="publishName"
            aria-label="publish-name"
            onChange={this.handleCheckboxChange}
            checked={publishName.value}
          />
          {this.props.isGaw ? (
            <CheckboxLabel>Please do not publish my name.</CheckboxLabel>
          ) : (
            <CheckboxLabel>
                 <Contents.Consumer>
                {(props) => {
                  if (
                    props &&
                    props.page_checkbox &&
                    props.page_checkbox["Recommend a Grant"]
                  ) {
                    const extractedData = props.page_checkbox[
                      "Recommend a Grant"
                    ].filter((item) => item.name === "Permission to publish");
                    return extractedData.map((data) => {
                        return (
                          <span key={data.name}
                            dangerouslySetInnerHTML={{ __html: data.field_checkbox_conent }}
                          ></span>
                        );
                    });
                  }
                }}
              </Contents.Consumer>
            </CheckboxLabel>
          )}
        </DisplayFlex>
      </div>
    );
  }
}

PermissionToPublishForm.propTypes = {
  page: PropTypes.string,
  isGaw: PropTypes.bool,
  publishCheck: PropTypes.bool,
}

export default PermissionToPublishForm;
